<!-- form panel -->
<div class="p-1">
    <div class="rounded p-1 text-dark">
        <!-- header -->
        <div class="d-flex justify-content-between align-items-center collapse-toggle clickable" data-toggle="collapse" 
            data-target="#print-content-collapse" aria-expanded="true" aria-controls="print-content-collapse">
            <button class="btn btn-light btn-xs">
                <span class="collapse-icon"></span>
            </button>
            <h4 class="text-dark">Print Center</h4>
            <div class="actions">&nbsp;</div>
        </div>

        <div class="collapse show" id="print-content-collapse">
            <div class="p-2">
                <div class="row">
                    <div class="col">

                        <div class="card-columns">

                            @for (group of groupKeys; track group) {
                                <div class="card">
                                    <div class="card-body">
                                        <h4 class="card-title">{{group | titlecase}} Documents</h4>
                                        <ul class="list-group list-group-flush">
                                            @for (form of formKeys(group); track form) {
                                                <li class="list-group-item clickable">
                                                    <p (click)="view(group, form)" [title]="revision(group, form)">{{form}}</p>
                                                    <div class="actions">
                                                        @if (allowSetupValueChanges(group, form)) {
                                                            <button class="btn btn-sm btn-outline-primary" (click)="openModal(group, form)"><span class="uil-cog"></span></button>
                                                        }
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }

                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- Pdf View Modal -->
<button id="btn-view-pdf-modal" data-target="#pdfViewModal" data-toggle="modal" class="btn btn-sm d-none"></button>
<div id="pdfViewModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="pdfViewModal">
    <div class="modal-dialog modal-full-width">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Forms</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                @if (pdf) {
                <object type="application/pdf" [data]="pdf" width="100%" height="90%"></object>
                }
            </div>
        </div>
    </div>
</div>

<button id="btn-view-dynamicSetupForm-modal" data-target="#dynamicSetupForm" data-toggle="modal" class="btn btn-sm d-none"></button>
<div id="dynamicSetupForm" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="dynamicSetupForm">
    <dynamic-setup-form [setupValues]="setupValuesString" [selectedForm]="selectedForm" [inventoryId]="inventoryId"></dynamic-setup-form>
</div>
